import type { IconProps } from './types';
import './icons.css';

export default function TableSettings({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-table-settings ${className || ''}`}
    >
      <path
        d="M15.7071 6.68557L13.6515 6.34957C13.5311 5.93704 13.3666 5.54052 13.1607 5.16522L14.3607
        3.45496C14.4577 3.31687 14.441 3.1287 14.3217 3.00904L12.969 1.65704C12.8483 1.5367 12.6584
        1.52104 12.52 1.62087L10.8355 2.83165C10.4567 2.62226 10.0567 2.456 9.64174 2.3353L9.28313
        0.288C9.25391 0.121739 9.10957 0 8.94052 0H7.02748C6.85704 0 6.71165 0.123478 6.68417
        0.291826L6.35165 2.328C5.93426 2.448 5.53357 2.61252 5.15617 2.81913L3.47617 1.61913C3.33739
        1.52 3.14852 1.536 3.02783 1.656L1.67583 3.008C1.55652 3.1273 1.53983 3.31513 1.63687 3.45322L2.81913
        5.1447C2.6087 5.52557 2.44104 5.9287 2.31896 6.34817L0.290783 6.68591C0.12313 6.71374 0 6.85913
        0 7.02887V8.94191C0 9.11061 0.121043 9.25496 0.286956 9.28452L2.31513 9.64417C2.43652 10.0626
        2.60417 10.4657 2.8153 10.8477L1.61843 12.5217C1.51965 12.6598 1.5353 12.8494 1.6553 12.9701L3.00765
        14.3235C3.12696 14.4428 3.31513 14.4595 3.45322 14.3624L5.14713 13.176C5.5273 13.385 5.92904
        13.551 6.34539 13.6713L6.68487 15.7099C6.71235 15.8772 6.85739 16 7.02748 16H8.94052C9.10922
        16 9.25357 15.879 9.28278 15.713L9.64626 13.6643C10.0633 13.5416 10.463 13.3746 10.8393
        13.1652L12.5454 14.3621C12.6838 14.4598 12.8717 14.4428 12.9913 14.3235L14.3437 12.9701C14.464
        12.8494 14.4797 12.6591 14.3798 12.5207L13.1631 10.8313C13.3694 10.4557 13.5332 10.0584 13.6525
        9.64591L15.711 9.28452C15.8776 9.2553 15.9986 9.11061 15.9986 8.94191V7.02887C15.999 6.85844
        15.8755 6.71304 15.7071 6.68557ZM7.9993 10.4348C6.65461 10.4348 5.56452 9.3447 5.56452
        8C5.56452 6.6553 6.65461 5.56522 7.9993 5.56522C9.344 5.56522 10.4341 6.6553 10.4341 8C10.4341
        9.3447 9.344 10.4348 7.9993 10.4348Z"
        fill="currentColor"
      />
    </svg>
  );
}
